import React from "react";
import ProductFilterListSplit from "./ProductFilterListSplit";

/**
 *
 * @param props {{data: object}}
 * @returns {JSX.Element}
 */
export default (props) => (
  <ProductFilterListSplit {...props} isExpandable isFilebase />
);
